import { render, staticRenderFns } from "./OperatorStatistics.vue?vue&type=template&id=03b8bd91&"
import script from "./OperatorStatistics.vue?vue&type=script&lang=js&"
export * from "./OperatorStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports